export const apiUrl = {
  testUrl: "https://brandlift.mdundoforbrands.com/api",
  baseUrl: "https://brandlift.mdundoforbrands.com/api",
};
